const BASE_URL: string = process.env.REACT_APP_API_KEY || '';
// const BASE_URL: string = 'http://178.128.61.122:8083';

export const FIND_MANY_DRIVER_FINANCIAL = BASE_URL + '/rider/clear-money/find-many';
export const CLEAR_MONEY_DRIVER_FINANCIAL =
  BASE_URL + '/rider/clear-money/clear-money?clearMoneyId=';
export const PAY_MONEY_DRIVER_FINANCIAL =
  BASE_URL + '/rider/clear-money/update-pay-money-rider?riderId=';

export const IMAGE_SUBMISSION = BASE_URL + '/rider/';

export const CREATE_SUBMISSION = BASE_URL + '/rider/balance/create-submission';

export const FIND_OLD_MULTIPLIER = BASE_URL + '/rider/multiplier/find-one-by-admin';

export const UPDATE_MULTIPLIER = BASE_URL + '/rider/multiplier/update?id=';

export const CONFIRM_SUBMISSION = BASE_URL + '/rider/balance/confirm-by-admin?submissionId=';

export const DELETE_SUBMISSION = BASE_URL + '/rider/balance/delete-submission';